export const mapNames = {
  BAHAMAS: 'The Bahamas',
  BAHRAIN: '-------',
  'BOSNIA AND HERZEGOVINA': 'Bosnia and Herzegovina',
  'BURKINA FASO': 'Burkina Faso',
  'COSTA RICA': 'Costa Rica',
  'CZECH REPUBLIC': 'Czech Republic',
  CZECHOSLAVAKIA: 'Czech Republic',
  "CÃ”TE D'IVOIRE": 'Ivory Coast',
  'DOMINICAN REPUBLIC': 'Dominican Republic',
  'EL SALVADOR': 'El Salvador',
  'FRENCH GUIANA': '-------',
  'FRENCH POLYNESIA': '-------',
  'HEARD ISLAND AND MCDONALD ISLANDS': '------',
  'HONG KONG': '-------',
  'IRAN, ISLAMIC REPUBLIC OF': 'Iran',
  "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF": 'North Korea',
  'KOREA, REPUBLIC OF': 'South Korea',
  'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF': 'Macedonia',
  MALTA: '-------',
  'MOLDOVA, REPUBLIC OF': 'Moldova',
  MONACO: '--------',
  'NEW ZEALAND': 'New Zealand',
  'PUERTO RICO': '---------',
  'RUSSIAN FEDERATION': 'Russia',
  'SAUDI ARABIA': 'Saudi Arabia',
  SERBIA: 'Republic of Serbia',
  'SERBIA AND MONTENEGRO': '--------',
  SINGAPORE: '--------',
  'SOUTH AFRICA': 'South Africa',
  'SRI LANKA': 'Sri Lanka',
  'SYRIAN ARAB REPUBLIC': 'Syria',
  TAIWAN: '------',
  'TANZANIA, UNITED REPUBLIC OF': 'United Republic of Tanzania',
  'TRINIDAD AND TOBAGO': 'Trinidad and Tobago',
  'UNITED ARAB EMIRATES': 'United Arab Emirates',
  'UNITED KINGDOM': 'United Kingdom',
  'UNITED STATES': 'United States of America',
  'VENEZUELA, BOLIVARIAN REPUBLIC OF': 'Venezuela',
  'VIET NAM': 'Vietnam',
  YUGOSLAVIA: '---------',
};
